module.exports = __webpack_public_path__ + "img/bold-icon add.83b3c6ee.svg";